module["exports"] = [" փողոց", " պողոտա"];